import React, { useState, useEffect } from 'react';

const Typewriter = ({ text, speed = 5, onComplete, onProgress }) => {
    const [displayedText, setDisplayedText] = useState('');
    const [index, setIndex] = useState(0);

    useEffect(() => {
        if (!text) return;

        // 텍스트가 다 타이핑될 때까지 반복
        if (index < text.length) {
            let currentStr = text[index];
            let nextIndex = index;

            // '<' 기호를 만났을 때 이게 진짜 HTML 태그인지 검사
            if (currentStr === '<') {
                const nextChar = text[index + 1];
                const isHtmlTag = /^[a-zA-Z\/]$/.test(nextChar || '');

                if (isHtmlTag) {
                    // 진짜 HTML 태그라면 닫는 '>' 기호를 찾아서 한 덩어리로 처리
                    const closeIndex = text.indexOf('>', index);
                    if (closeIndex !== -1) {
                        currentStr = text.substring(index, closeIndex + 1);
                        nextIndex = closeIndex;
                    }
                }
            }

            const timeout = setTimeout(() => {
                setDisplayedText((prev) => prev + currentStr);
                setIndex(nextIndex + 1);
                if (onProgress) onProgress();
            }, speed);

            return () => clearTimeout(timeout);
        } else if (onComplete) {
            onComplete();
        }
    }, [index, text, speed, onComplete, onProgress]);

    return <span dangerouslySetInnerHTML={{ __html: displayedText }} />;
};

export default Typewriter;
